module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.ef3526e.woff";